export default __webpack_public_path__ + "static/media/inner-tech-augmented-workforce.a8dab5d7.svg";